import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";
import { MapProvider } from "../context/MapContext";
import { RequiredProvider } from "../pages/GeneralRegistration/Context";
import { SimuladorProvider } from "../pages/SalesManagement/Enterprise/Simulator/SimulatorContext";
import { ParcelProvider } from "../pages/SalesManagement/Enterprise/Negotiations/Contracts/Parcel/ParcelContext";

import Map from "../pages/SalesManagement/Enterprise/Map/Map";
import Enterprise from "../pages/SalesManagement/Enterprise/Enterprise";
import Documents from "../pages/SalesManagement/Enterprise/Documents/Documents";
import Simulator from "../pages/SalesManagement/Enterprise/Simulator/Simulator";
import Parcel from "../pages/SalesManagement/Enterprise/Negotiations/Contracts/Parcel/Parcel";
import EnterpriseDashboard from "../pages/SalesManagement/Enterprise/Dashboard/EnterpriseDashboard";
import ContractAdjustment from "../pages/SalesManagement/Enterprise/ContractAdjustment/ContractAdjustment";
import ContractDetails from "../pages/SalesManagement/Enterprise/Negotiations/Contracts/ContractDetails/ContractDetails";
import ReversalReport from "../pages/Financial/ReversalReport/ReversalReport";
import { GoogleMapsView } from "../pages/SalesManagement/Enterprise/GoogleMaps/GoogleMapsView";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const EnterpriseRoutes = () => (
  <SimuladorProvider>
    <MapProvider>
      <PrivateRoute>
        <RequiredProvider>
          <Routes>
            <Route path="/map/:id" element={<Map />} />
            <Route path="/:id" element={<Enterprise />} />
            <Route path="/googleMaps/:id" element={<GoogleMapsView />} />
            <Route path="/documents/:id" element={<Documents />} />
            <Route path="/contracts/parcel" element={
              <ParcelProvider>
                <Parcel />
              </ParcelProvider>
            } />
            <Route path="/simulator/:id?" element={<Simulator />} />
            <Route path="/dashboard/:id" element={<EnterpriseDashboard />} />
            <Route path="/contracts/details" element={<ContractDetails />} />
            <Route
              path="/contractAdjustment/:id?"
              element={<ContractAdjustment />}
            />
            <Route
              path="/contracts/parcel/reverseParcel"
              element={<ReversalReport />}
            />
            <Route
              path="/contracts/parcel/reverseParcel"
              element={<ReversalReport />}
            />
          </Routes>
        </RequiredProvider>
      </PrivateRoute>
    </MapProvider>
  </SimuladorProvider>
);
